import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-primary text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src="/logo/favicon.svg" alt="EduManage Logo" className="h-6 w-6 mr-2 rounded-full" />
            <span className="text-xl font-bold text-white">EduManage</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="hover:text-secondary transition">Home</Link>
            <Link to="/notices" className="hover:text-secondary transition">Notices</Link>
            <Link to="/admission" className="hover:text-secondary transition">Admission</Link>
            <Link to="/teachers" className="hover:text-secondary transition">Teachers</Link>
            <Link to="/results" className="hover:text-secondary transition">Results</Link>
            <Link to="/gallery" className="hover:text-secondary transition">Gallery</Link>
            <Link to="/contact" className="hover:text-secondary transition">Contact</Link>

            {isAuthenticated ? (
              <div className="relative group">
                <button className="flex items-center space-x-1 hover:text-secondary transition">
                  <FaUser className="mr-1" />
                  <span>{user?.name}</span>
                </button>
                <div className="absolute right-0 mt-2 w-48 bg-white text-gray-800 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                  {user?.role === 'student' && (
                    <>
                      <Link to="/student/dashboard" className="block px-4 py-2 hover:bg-gray-100">Dashboard</Link>
                      <Link to="/student/profile" className="block px-4 py-2 hover:bg-gray-100">Profile</Link>
                    </>
                  )}
                  {user?.role === 'teacher' && (
                    <>
                      <Link to="/teacher/dashboard" className="block px-4 py-2 hover:bg-gray-100">Dashboard</Link>
                      <Link to="/teacher/profile" className="block px-4 py-2 hover:bg-gray-100">Profile</Link>
                    </>
                  )}
                  {user?.role === 'admin' && (
                    <>
                      <Link to="/admin/dashboard" className="block px-4 py-2 hover:bg-gray-100">Admin Panel</Link>
                      <Link to="/admin/notices" className="block px-4 py-2 hover:bg-gray-100">Manage Notices</Link>
                    </>
                  )}
                  <button 
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center"
                  >
                    <FaSignOutAlt className="mr-2" /> Logout
                  </button>
                </div>
              </div>
            ) : (
              <Link to="/login" className="bg-secondary text-primary px-6 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition shadow-md hover:shadow-lg">
                Login
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsOpen(!isOpen)}
              className="text-white focus:outline-none"
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-3">
              <Link to="/" className="hover:text-secondary transition" onClick={() => setIsOpen(false)}>Home</Link>
              <Link to="/notices" className="hover:text-secondary transition" onClick={() => setIsOpen(false)}>Notices</Link>
              <Link to="/admission" className="hover:text-secondary transition" onClick={() => setIsOpen(false)}>Admission</Link>
              <Link to="/teachers" className="hover:text-secondary transition" onClick={() => setIsOpen(false)}>Teachers</Link>
              <Link to="/results" className="hover:text-secondary transition" onClick={() => setIsOpen(false)}>Results</Link>
              <Link to="/gallery" className="hover:text-secondary transition" onClick={() => setIsOpen(false)}>Gallery</Link>
              <Link to="/contact" className="hover:text-secondary transition" onClick={() => setIsOpen(false)}>Contact</Link>

              {isAuthenticated ? (
                <div className="mt-2 pt-2 border-t border-gray-600">
                  <div className="font-semibold">{user?.name} ({user?.role})</div>
                  {user?.role === 'student' && (
                    <>
                      <Link to="/student/dashboard" className="block mt-1 hover:text-secondary transition" onClick={() => setIsOpen(false)}>Dashboard</Link>
                      <Link to="/student/profile" className="block hover:text-secondary transition" onClick={() => setIsOpen(false)}>Profile</Link>
                    </>
                  )}
                  {user?.role === 'teacher' && (
                    <>
                      <Link to="/teacher/dashboard" className="block mt-1 hover:text-secondary transition" onClick={() => setIsOpen(false)}>Dashboard</Link>
                      <Link to="/teacher/profile" className="block hover:text-secondary transition" onClick={() => setIsOpen(false)}>Profile</Link>
                    </>
                  )}
                  {user?.role === 'admin' && (
                    <>
                      <Link to="/admin/dashboard" className="block mt-1 hover:text-secondary transition" onClick={() => setIsOpen(false)}>Admin Panel</Link>
                      <Link to="/admin/notices" className="block hover:text-secondary transition" onClick={() => setIsOpen(false)}>Manage Notices</Link>
                    </>
                  )}
                  <button 
                    onClick={handleLogout}
                    className="w-full text-left mt-2 flex items-center hover:text-secondary transition"
                  >
                    <FaSignOutAlt className="mr-2" /> Logout
                  </button>
                </div>
              ) : (
                <Link to="/login" className="block mt-2 bg-secondary text-primary px-4 py-3 rounded-lg font-semibold text-center shadow-md" onClick={() => setIsOpen(false)}>
                  Login
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;